import './App.css';
import Header from './components/Header/Header';
import { Route, Routes } from 'react-router-dom';
import About from './pages/About';
import Proposals from './pages/Proposals';
import Results from './pages/Results';
import Voting from './pages/Voting';
import Prizes from './pages/Prizes';
import Sponsoring from './pages/Sponsoring';
import Footer from './components/Footer/Footer';
import VotingVerifications from './pages/VotingVerifications';

const App = () => {
	return (
		<>
			<Header />
			<Routes>
				<Route Component={About} path='/' />
				<Route element={<Proposals />} path='/propozycje' />
				<Route Component={VotingVerifications} path='/verify-vote' />
				<Route Component={Voting} path='/glosowanie' />
				<Route Component={Results} path='/wyniki' />
				<Route Component={Prizes} path='/nagrody' />
				<Route Component={Sponsoring} path='/sponsorzy' />
			</Routes>
			<Footer />
		</>
	);
};

export default App;
